import { Auth } from 'aws-amplify';

const Supplier = {
  FIBRE1_ZEN: "Fibre1",
  FIBRE1_GIGANET: "Fibre1",
  FAELIX_ZEN: "Hightide",
  NIMANS_ZEN: "Zen",
}

export const supplierKey = {
  ZEN: "ZEN",
  GIGANET: "GIGANET"
};

export async function getSupplier(supplierKey = '', useTenant = false) {
  const session = await Auth.currentSession();
  const tenant = session?.idToken?.payload["custom:tennant"];
  return useTenant && !supplierKey ? tenant : Supplier[`${tenant}_${supplierKey}`.toUpperCase()];
}

export async function getCustomer(){
  const session = await Auth.currentSession();
  return session?.idToken?.payload["custom:customer"];
}

export async function getIsLayer2(){
  const session = await Auth.currentSession();
  return session?.idToken?.payload["custom:L2"];
}

export async function getSuppliers(){
  const session = await Auth.currentSession();
  var suppliers = session?.idToken?.payload["custom:suppliers"];
  suppliers = JSON.parse(suppliers.replace(/(\w*):/g, '"$1":'))
  return suppliers != null ? suppliers["Onboarded"] : {};
}

export async function showCustomMessage(){
  const session = await Auth.currentSession();
  const tennant = session?.idToken?.payload["custom:tennant"];
  return (tennant === "Fibre1") ? true : false;
}

export async function getLoggedOnPartner(){
  const session = await Auth.currentSession();
  const partner = session?.idToken?.payload["custom:customer"];
  return partner;
}
